import { IPosition } from './position'
import { IPositionType } from './position-type'

export enum IOlexMatchStatus {
  Ready = 0,
  NotADraft = 1,
  NotSupported = 2,
  NotPlaced = 3,
  NoCoordinates = 4,
  InvalidFile = 5,
  NoOverlap = 6,
  OffGrid = 7,
  NamesExhausted = 8,
}

export interface IOlexMatchGroup {
  type: IPositionType
  kept: number
  added: string[]
  removed: string[]
}

export enum IOlexNameIssue {
  None = 0,
  Taken = 1,
  WrongType = 2,
  // Allowed: a removed or earlier position had this name.
  Reused = 3,
}

// A position the file names differently; the file name can only be taken when it has no issue.
export interface IOlexName {
  type: IPositionType
  name: string
  olexName: string
  issue: IOlexNameIssue
}

// A line the upload would remove, or one already moved by hand, with the corner it starts from.
export interface IOlexMovableLine {
  id: number
  // The name it has now.
  name: string
  corner: string
  // Index of the file line it is moved to by hand.
  fileLine?: number
  // The name it has after the upload, once moved.
  nameAfter?: string
}

// A line of the file that would become a new line, or that a line is already moved onto.
export interface IOlexFileLine {
  index: number
  // The name the line on this file line has after the upload, as the map shows it.
  name: string
  // The file's own name for it.
  olexName: string
  corner: string
  // Id of what sits here among the preview's positions (new lines have negative ids).
  positionId?: number | null
}

// What uploading a re-surveyed Olex file would do to the draft.
export interface IOlexMatchPreview {
  status: IOlexMatchStatus
  groups: IOlexMatchGroup[]
  movableLines: IOlexMovableLine[]
  fileLines: IOlexFileLine[]
  names: IOlexName[]
  useOlexNames: boolean
  offGrid: string[]
  cages: number
  rows: number
  pens: number
  mooringLines: number
  // The draft after the upload; positions it adds have negative ids.
  positions: IPosition[]
}
